



































/**
 * Logica: se esiste ed è popolato il blocco cms home_best_seller si usa quello,
 * altrimenti si prende il primo sku di highlighted_products_sku per ogni sottocategoria di "Prodotti",
 * altrimenti per ogni sottocategoria di "Prodotti" si prende il prodotto con maggior positioning (a parità di positioning si prende il più recente) 
 */
import { defineComponent, ref, useContext, useFetch } from '@nuxtjs/composition-api'
import axios from 'axios';
import { useContent, useConfig } from '~/composables';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { getAsJSON } from '~/utils/solepro/CmsComponentAggregator';
import { extendProductsForBox, getProductTypesParentCategory } from '~/utils/solepro/products';
import ProductBox from '~/components/solepro/ProductBox.vue';
import { Pagination, Navigation } from 'swiper'
import { bestSellerNavTrack, bestSellerCardTrack } from '~/helpers/trackings/24orepro/home';
import { getAxiosConfigs } from '~/utils/solepro/functions';

import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'

// Import Swiper styles
import 'swiper/swiper-bundle.css'

SwiperCore.use([Pagination, Navigation])
export default defineComponent({
    components: {
        ProductBox,
        Swiper,
        SwiperSlide
    },
    setup() {
        const { loadBlocks } = useContent();
        const categoryStore = useCategoryStore();
        const blocks = ref([]);
        const canShow = ref<Boolean>(false);
        const { isDev, app } = useContext();
        const { config } = useConfig();
        
        useFetch(async () => {
            await categoryStore.load();
            const categories = categoryStore.rawCategories?.items[0].children;

            const home_best_seller = await loadBlocks({ identifiers: ["home_best_seller"] });
            if (!!home_best_seller && !!home_best_seller[0]) {
                const contentTree = getAsJSON(home_best_seller[0].content, false, isDev, false)
                try {
                    const carousel = contentTree.children[0].children[0];
                    const res = await axios.post('/sole-api/product/pro/getProductBaseDataForBox', { skus: carousel.skus }, { ...getAxiosConfigs(app, config) });
                    blocks.value = extendProductsForBox(categories, res.data)
                } catch (e) {
                    console.warn(" Evidence Products Home slider failed: ", e)
                }
            } else {
                const { data } = await axios.get('/sole-api/category/pro/categoryHighlightedProducts?limit=1&categoryName=Prodotti', { ...getAxiosConfigs(app, config) });
                const products = data.map(el => el.highlighted_products_details).filter(el => !!el).flat();
                const hasHighlighted = products.length
                if (!!hasHighlighted) {
                    blocks.value = extendProductsForBox(categories, products)
                } else {
    
                    const topresp = await axios.get(`/sole-api/product/pro/getTopProducts/${getProductTypesParentCategory(categories).id}`, { ...getAxiosConfigs(app, config) });
                    const hasTopProducts = topresp.data.length
                    if (hasTopProducts) {
                        blocks.value = topresp.data;
    
                    } else {
                        console.log('NO EVIDENCE PRODUCTS')
    
                    }
                }
            }
        });

        const swiperProps = {
            slidesPerView: "auto",
            spaceBetween: 12,
            modules: [Navigation, Pagination],
            slideClass: 'slide',
            pagination: {
                el: '.evidence-products .pagination',
                type: 'progressbar',
                progressbarFillClass: 'bg-black w-full block h-full'
            },
            navigation: {
                prevEl: '.evidence-products .navigation-prev',
                nextEl: '.evidence-products .navigation-next'
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1366: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        }

        const trackBestSellerNav = (val) => bestSellerNavTrack(val);
        const trackBestSellerLink = (val, callback) => bestSellerCardTrack(val, callback); 

        return {
            blocks,
            swiperProps,
            canShow,
            trackBestSellerLink,
            trackBestSellerNav
        }
    },
    methods: {
        calculateHeights(swiper){
            const slides = swiper.$el[0].querySelectorAll('.slide');

            const tallest = Array.from(slides).reduce((tallest: Element, slide: Element) => {
                    return slide.querySelector('.product-box').getBoundingClientRect().height > tallest.querySelector('.product-box').getBoundingClientRect().height ? slide : tallest;
                });
                const h = (tallest as HTMLElement).offsetHeight+'px';
                slides.forEach(el=>el.querySelector('.product-box').style.height = h)
        },
        afterInit(swiper) {
            /** UGLY, VERY UGLY Try to check why the resize / swiper don't work as espected */
            const interval = setInterval(()=>{
                if(!swiper.$el) return;
                const slides = swiper.$el[0].querySelectorAll('.slide');
                if(slides.length>1){
                    clearInterval(interval);
                    setTimeout(()=>{
                        this.canShow = true
                        setTimeout(()=>{
                            swiper.update();
                            console.log('updated');
                           this.calculateHeights(swiper);
                        },0)
                    },1000)
                }
            },300)
            setTimeout(() => {
                clearInterval(interval)
            }, 10000)
        }
    }
})
